var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addPaper" },
    [
      _vm.resourcesFrom == "1"
        ? _c(
            "div",
            { staticClass: "addPaper_head" },
            [
              _c("span"),
              _vm._v(" "),
              _c("el-input", {
                staticStyle: { width: "190px" },
                attrs: {
                  size: "mini",
                  placeholder: "请输入内容",
                  "suffix-icon": "el-icon-search",
                  clearable: ""
                },
                on: { clear: _vm.inputSearch },
                nativeOn: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.inputSearch.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { flex: "1", position: "relative" } },
        [
          _c(
            "el-table",
            {
              staticStyle: { position: "absolute" },
              attrs: {
                data: _vm.questionList,
                height: "calc(100% - 80px)",
                "cell-style": { textAlign: "left" },
                "header-cell-style": { textAlign: "left" }
              },
              on: { "row-click": _vm.rowClick }
            },
            [
              _c("el-table-column", {
                attrs: { label: "", width: "35" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.id },
                            model: {
                              value: _vm.currentValue,
                              callback: function($$v) {
                                _vm.currentValue = $$v
                              },
                              expression: "currentValue"
                            }
                          },
                          [_vm._v(" ")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm._l(_vm.tableHeader, function(item) {
                return _c("el-table-column", {
                  key: item.prop,
                  attrs: {
                    prop: item.prop,
                    label: item.label,
                    width: item.width || "auto",
                    fixed: item.fixed ? item.fixed : false,
                    "show-overflow-tooltip": item.showOverflow
                      ? item.showOverflow
                      : false,
                    align: item.align ? item.align : "center"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            item.prop != "operation"
                              ? _c("div", {
                                  attrs: { title: scope.row[item.prop] },
                                  domProps: {
                                    textContent: _vm._s(scope.row[item.prop])
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#1890FF" },
                            attrs: { size: "mini", type: "text" },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.previewBtn(scope.row, scope.$index)
                              }
                            }
                          },
                          [_vm._v("\n            预览\n          ")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "empty_material",
                  attrs: { slot: "empty" },
                  slot: "empty"
                },
                [_c("p", [_vm._v("暂无作业")])]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c("Pagination", {
            staticStyle: { position: "absolute", bottom: "0", right: "0" },
            attrs: {
              currentpage: _vm.pageTotal.currentPage,
              limit: _vm.pageTotal.pageSize,
              total: _vm.pageTotal.total,
              layout: "sizes, prev, pager, next, jumper",
              small: true
            },
            on: {
              handleCurrentChange: _vm.handleCurrentChange,
              handleSizeChange: _vm.handleSizeChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("n-dialog", {
        attrs: {
          title: "提示",
          dialogVisible: _vm.addTestPaperShow,
          width: "400px",
          dialogType: _vm.dialogType,
          deleteNum: "1",
          deleteName: _vm.deleteName,
          isDedicated: _vm.isDedicated
        },
        on: { conformFunc: _vm.conformFunc, closeDialog: _vm.closeDialog }
      }),
      _vm._v(" "),
      _c("create-work", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShowCreateWorkDialog,
            expression: "isShowCreateWorkDialog"
          }
        ],
        attrs: {
          isShowCreateWorkDialog: _vm.isShowCreateWorkDialog,
          dialogData: _vm.dialogData,
          isNotEdit: _vm.isNotEdit,
          dialogTitle: "预览作业模版",
          "append-to-body": true
        },
        on: { handleClose: _vm.closeDialogWork }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e4f6196", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4f6196","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/addWork.vue
// module id = null
// module chunks = 